import types from '../types';

const vacancies = (
  state = { loading: true, data: null, single: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_VACANCIES_START:
    case types.GET_SINGLE_VACANCY_START:
      return { ...state, single: null, loading: true };

    case types.GET_VACANCIES_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_VACANCIES_FAILURE:
      return { ...state, loading: false };

    case types.GET_SINGLE_VACANCY_SUCCESS:
      return { ...state, single: payload, loading: false };

    case types.DELETE_VACANCIES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          data: state.data.data.filter(vacancy => vacancy.id !== +payload),
        },
      };

    default:
      return state;
  }
};

export default vacancies;
